/*
  FAQ group: animates native <details> rows. Rows are independent (several may be open).
  Without JS, or with reduced motion, the rows toggle natively with no animation.
*/
if (!customElements.get('fable-page-faq')) {
  customElements.define(
    'fable-page-faq',
    class FablePageFaq extends HTMLElement {
      constructor() {
        super();
        this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.onClick = this.onClick.bind(this);
        this.onBlockSelect = this.onBlockSelect.bind(this);
        this.openFromHash = this.openFromHash.bind(this);
      }

      // every listener is added here and removed in disconnectedCallback, so the
      // element keeps exactly one set when the theme editor moves the section
      connectedCallback() {
        this.addEventListener('click', this.onClick);
        this.addEventListener('shopify:block:select', this.onBlockSelect);
        window.addEventListener('hashchange', this.openFromHash);
        this.openFromHash();
      }

      disconnectedCallback() {
        this.removeEventListener('click', this.onClick);
        this.removeEventListener('shopify:block:select', this.onBlockSelect);
        window.removeEventListener('hashchange', this.openFromHash);

        // settle rows that were caught mid-animation
        this.querySelectorAll('details').forEach((item) => {
          if (!item.faqAnimation) return;
          item.faqAnimation.cancel();
          item.faqAnimation = null;
          if (item.classList.contains('is-closing')) {
            item.classList.remove('is-closing');
            item.open = false;
          }
        });
      }

      onClick(event) {
        const summary = event.target.closest('summary');
        if (!summary || !this.contains(summary)) return;
        const item = summary.parentElement;
        if (!item || !item.matches('details')) return;
        event.preventDefault();
        this.toggle(item, !item.open || item.classList.contains('is-closing'));
      }

      // theme editor: reveal the selected question
      onBlockSelect(event) {
        const item = event.target.closest('details');
        if (item && this.contains(item)) this.toggle(item, true, true);
      }

      // deep link: #faq-<section key>-<block id>
      openFromHash() {
        let id = '';
        try {
          id = decodeURIComponent(window.location.hash.slice(1));
        } catch (error) {
          return;
        }
        const target = id ? document.getElementById(id) : null;
        if (target && this.contains(target) && target.matches('details')) this.toggle(target, true, true);
      }

      toggle(item, open, instant) {
        const panel = item.querySelector('.fable-page-faq__content');
        if (item.faqAnimation) {
          item.faqAnimation.cancel();
          item.faqAnimation = null;
        }
        item.classList.remove('is-closing');

        if (instant || !panel || typeof panel.animate !== 'function' || this.reducedMotion.matches) {
          item.open = open;
          return;
        }

        const options = { duration: 300, easing: 'cubic-bezier(0.4, 0, 0.2, 1)' };

        if (open) {
          item.open = true;
          item.faqAnimation = panel.animate({ height: ['0px', `${panel.scrollHeight}px`] }, options);
          item.faqAnimation.onfinish = () => {
            item.faqAnimation = null;
          };
        } else {
          item.classList.add('is-closing');
          item.faqAnimation = panel.animate({ height: [`${panel.offsetHeight}px`, '0px'] }, options);
          item.faqAnimation.onfinish = () => {
            item.open = false;
            item.classList.remove('is-closing');
            item.faqAnimation = null;
          };
        }
      }
    }
  );
}
